import { LazyLoadWithCircularProgress } from '../../core/lazyLoad'

import { EDITOR } from '@eig-builder/core-utils/analytics/page-types'
import { STORE } from '@eig-builder/core-utils/analytics/flow-types'

const Routes = [{
  path: '/notfound',
  component: LazyLoadWithCircularProgress(() => import('./components/notfound')),
  pageTitle: 'NotFound',
  exactly: true,
  isPublic: true,
  pageType: EDITOR,
  flowType: STORE
}]

export default Routes
